import { render, staticRenderFns } from "./PosPriority.vue?vue&type=template&id=6cb28788&"
import script from "./PosPriority.vue?vue&type=script&lang=js&"
export * from "./PosPriority.vue?vue&type=script&lang=js&"
import style0 from "./PosPriority.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports